import { action, makeObservable, observable } from 'mobx';
import { singleton } from 'tsyringe';

import { GetStudyPlanCollaboration } from '@/application/collaborations/get-study-plan.collaboration';

import { ClassifiersModel } from './classifiers.model';

@singleton()
export class StudyPlanModel {
  @observable shouldShowStudyPlanTab = false;

  constructor(
    private readonly studyPlanCollaboration: GetStudyPlanCollaboration,
    private readonly classifiersModel: ClassifiersModel,
  ) {
    makeObservable(this);
  }

  @action.bound
  async getStudyPlan() {
    try {
      const classifierGuid = this.classifiersModel.selectedClassifier.guid;
      const { data } = await this.studyPlanCollaboration.run(classifierGuid);
      if (data) {
        this.shouldShowStudyPlanTab = true;
      }
    } catch (error) {
      this.shouldShowStudyPlanTab = false;
    }
  }
}
